//
// Suggestion Dropdown
// A view controller that is used for the AI Assist Widget to provide user feedback
//

define(function(require) {
  var ViewController = require('web-agent-framework/ViewController');

  var SuggestionDropdownViewController = ViewController.extend({
    ControllerName: 'SuggestionDropdownViewController',

    LPViewMap: {
      dropdownItem: '.lp_ai_assist_dropdown_item',
      input: '.lp_ai_assist_input'
    },

    initialize: function(data) {
      // Set context variables
      this.reason = data.reason;
      this.setInputText = data.setInputText;
      this.hideDropdown = data.hideDropdown;

      // Inject content to DOM
      this.getFirstElement(this.LPViewMap.dropdownItem).textContent =
        data.reason;
    },

    events: function() {
      // Call the setInputText callback with the reason
      this.bindViewEvent({
        selector: this.LPViewMap.dropdownItem,
        DOMEvent: 'click',
        callback: this.setInput.bind(this)
      });
    },

    render: function() {}
  });

  SuggestionDropdownViewController.prototype.setInput = function() {
    this.setInputText(this.reason);
    this.hideDropdown();
  };

  return SuggestionDropdownViewController;
});
